import {
  ChangeDetectionStrategy,
  Component,
  inject,
  model,
} from '@angular/core';
import { ModalService } from '@features/modals/services/modal.service';
import { ToastrService } from 'ngx-toastr';

import { InputOptionsComponent } from '@core/components/input-options/input-options.component';
import { SvgIconComponent } from 'angular-svg-icon';
import { SessionService } from '@core/services/session.service';
import { RainService } from '../rain.service';

@Component({
  selector: 'app-tip-rain-modal',
  imports: [InputOptionsComponent, SvgIconComponent],
  templateUrl: './tip-rain-modal.component.html',
  styleUrl: './tip-rain-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  host: {
    class: 'modal-container flex flex-col',
  },
})
export class TipRainModalComponent {
  private modalService = inject(ModalService);
  private rainService = inject(RainService)
  private toastrService = inject(ToastrService);
  public sessionService = inject(SessionService);

  readonly minAmount = 1;
  amountS = model<number>(1);

  async handleTipRain($event: Event) {
    $event.preventDefault();
    $event.stopPropagation();
    const amount = this.amountS();

    if (amount < this.minAmount) {
      this.toastrService.error(
        `Please enter a valid amount, min ${this.minAmount}`
      );
      return;
    }

    try {
      const message = await this.rainService.tipRain(amount);
      if (message) {
        this.toastrService.success(message);
      }
      this.modalService.close();
    } catch (error) {
      console.log('🚀 ~ TipRainModalComponent ~ handleTipRain ~ error:', error);
    }
  }
}
